import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Download, Trash2, Upload } from 'lucide-react';
export function DataSettings() {
    return /*#__PURE__*/ _jsx("div", {
        className: "space-y-6",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-medium text-foreground mb-4",
                    children: "Data & Privacy"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "border border-border rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "font-medium text-foreground mb-2",
                                    children: "Export Your Data"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm text-muted-foreground mb-3",
                                    children: "Download a copy of all your data"
                                }),
                                /*#__PURE__*/ _jsxs("button", {
                                    className: "inline-flex items-center px-3 py-2 border border-input shadow-sm text-sm font-medium rounded-md text-foreground bg-card hover:bg-muted",
                                    children: [
                                        /*#__PURE__*/ _jsx(Download, {
                                            className: "w-4 h-4 mr-2"
                                        }),
                                        "Export Data"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "border border-border rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "font-medium text-foreground mb-2",
                                    children: "Import Data"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm text-muted-foreground mb-3",
                                    children: "Import data from another system"
                                }),
                                /*#__PURE__*/ _jsxs("button", {
                                    className: "inline-flex items-center px-3 py-2 border border-input shadow-sm text-sm font-medium rounded-md text-foreground bg-card hover:bg-muted",
                                    children: [
                                        /*#__PURE__*/ _jsx(Upload, {
                                            className: "w-4 h-4 mr-2"
                                        }),
                                        "Import Data"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "border border-danger rounded-lg p-4 bg-danger-muted",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "font-medium text-danger mb-2",
                                    children: "Delete Account"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm text-danger mb-3",
                                    children: "Permanently delete your account and all associated data. This action cannot be undone."
                                }),
                                /*#__PURE__*/ _jsxs("button", {
                                    className: "inline-flex items-center px-3 py-2 border border-danger shadow-sm text-sm font-medium rounded-md text-danger bg-danger-muted hover:bg-danger-muted",
                                    children: [
                                        /*#__PURE__*/ _jsx(Trash2, {
                                            className: "w-4 h-4 mr-2"
                                        }),
                                        "Delete Account"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
